<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  retrying: boolean;
  lang: string;
  reason?: "session" | "room";
}>();
defineEmits<{ retry: [] }>();

const copy = computed(() => {
  const language = props.lang.toLowerCase();
  if (props.reason === "room") {
    if (language === "vi")
      return {
        heading: "Không thể kết nối",
        description:
          "Hiện không thể xác minh phòng của bạn. Vui lòng kiểm tra kết nối và thử lại.",
        retry: "Thử lại",
        retrying: "Đang thử lại…",
      };
    return {
      heading: "Connection unavailable",
      description:
        "We could not verify your room right now. Check your connection and try again.",
      retry: "Retry",
      retrying: "Trying…",
    };
  }
  if (language === "th")
    return {
      heading: "ไม่สามารถเชื่อมต่อได้",
      description:
        "ไม่สามารถต่ออายุเซสชันของคุณได้ โปรดตรวจสอบการเชื่อมต่อแล้วลองอีกครั้ง",
      retry: "ลองอีกครั้ง",
      retrying: "กำลังลองอีกครั้ง…",
    };
  if (language === "id")
    return {
      heading: "Koneksi tidak tersedia",
      description:
        "Sesi tamu tidak dapat diperbarui. Periksa koneksi Anda dan coba lagi.",
      retry: "Coba lagi",
      retrying: "Mencoba lagi…",
    };
  return {
    heading: "Connection unavailable",
    description:
      "We could not refresh your guest session. Check your connection and try again.",
    retry: "Retry",
    retrying: "Trying…",
  };
});
</script>

<template>
  <main class="auth-unavailable" role="alert">
    <h1>{{ copy.heading }}</h1>
    <p>{{ copy.description }}</p>
    <button type="button" :disabled="retrying" @click="$emit('retry')">
      {{ retrying ? copy.retrying : copy.retry }}
    </button>
  </main>
</template>

<style scoped>
.auth-unavailable {
  max-width: 425px;
  min-height: 100vh;
  margin: auto;
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  background: #fff;
}

button {
  align-self: center;
  padding: 10px 24px;
  border: 0;
  border-radius: 8px;
  color: #fff;
  background: #1e355e;
}
</style>
